import { stdObject } from "../../../../data/types/stdObject";

export const updateStationaryItem = (
  code: number,
  values: stdObject,
  params: stdObject,
) => {
  const { docValues, setDocValues } = params;
  const index = docValues.parts.findIndex((e: stdObject) => e.NUMPAR === code);
  if (index > -1) {
    docValues.parts[index] = { ...docValues.parts[index], ...values };
    setDocValues({ ...docValues });
  }
  return true;
};
